mainApp.component('monitorOffcloud', {
    templateUrl: '/public/components/realtime/monitor-offcloud.component.html',
    bindings: {
        type: '=',
        item: '=?',
        pid: '=?',
    },
    controller: function ($scope, $timeout, $state, $element, $interval, $filter, ChartsService, GeneralUtilsService, IntervalService) {
        let ctrl = this;

        let currentSVG = "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z";
        let remoteConnectedSVG = "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z";
        let remoteDisconnectedSVG = "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z";
        let linkSVG = "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z";
        let linkOffSVG = "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z";

        let mapAreaColor = "#CDCDCD";
        let connectedColor = "green";
        let disconnectedColor = "grey";

        let connectedHTML = htmlForTooltip(connectedColor, remoteConnectedSVG);
        let disconnectedHTML = htmlForTooltip(disconnectedColor, remoteDisconnectedSVG);
        let offcloudLinkHTML = htmlForTooltip(connectedColor, linkSVG);
        let offcloudLinkOffHTML = htmlForTooltip(disconnectedColor, linkOffSVG);


        let MAX_CHART_ITEMS_COUNT = 60;
        let INTERVAL = 1000;
        let TIME_DELAY = 12000;
        let currentSiteId = {};
        let stop = false;
        let mapChart;
        let runTimeout;
        let chartData = initialChartData();
        let charts = [];
        let firstRun = true;
        let mapRepositioned = false;

        ctrl.selectedSiteAndTunnel = {};

        ctrl.$onInit = init;

        function init() {
            $scope.$root.realtime = true; // hide datepicker
            ctrl.accountId = $state.params.accountId;
            currentSiteId = ctrl.pid;
            loadSiteMapData();
            ctrl.tableConfig = buildTableConfig();
            chartsInit();
        }

        function chartsInit() {
            let upstreamThrougputChartSettings = createChartSettings('upstreamThroughput', 'Upstream Througput', value => $filter('bits')(Math.abs(value), 1) + 'ps');
            let upstreamThrougputChart = AmCharts.makeChart('upstreamThrougputChart', upstreamThrougputChartSettings);

            let downstreamThrougputChartSettings = createChartSettings('downstreamThroughput', 'Downstream Througput', value => $filter('bits')(Math.abs(value), 1) + 'ps');
            let downstreamThrougputChart = AmCharts.makeChart('downstreamThrougputChart', downstreamThrougputChartSettings);

            let packetLossChartSettings = createChartSettings('packetLoss', 'Packetloss', percentValueLabelFunction, percentValueBalloonFunction);
            let packetLossChart = AmCharts.makeChart('packetLossChart', packetLossChartSettings);

            let latencyChartSettings = createChartSettings('latency', 'Latency', millisecondsValueLabelFunction, millisecondsValueBalloonFunction);
            let latencyChart = AmCharts.makeChart('latencyChart', latencyChartSettings);

            let jitterSettings = createChartSettings('jitter', 'Jitter', millisecondsValueLabelFunction, millisecondsValueBalloonFunction);
            let jitterChart = AmCharts.makeChart('jitterChart', jitterSettings);

            charts.push(upstreamThrougputChart, downstreamThrougputChart, packetLossChart, latencyChart, jitterChart);
        }

        function percentValueLabelFunction(value) {
            return Math.abs(value) + '%';
        }

        function millisecondsValueLabelFunction(value) {
            return Math.abs(value) + 'ms';
        }

        function percentValueBalloonFunction(graphDataItem) {
            return Math.abs(graphDataItem.values.value) + '%';
        }

        function millisecondsValueBalloonFunction(graphDataItem) {
            return Math.abs(graphDataItem.values.value) + 'ms';
        }

        function initialChartData(time) {
            if(!time) {
                time = removeMs(new Date().getTime()) - TIME_DELAY;
            }
            let timePoints = [];
            for (let i = time - ((MAX_CHART_ITEMS_COUNT - 1) * INTERVAL); i <= time; i += INTERVAL) {
                timePoints.push({timestamp: i});
            }
            return timePoints;
        }

        function createChartSettings(valueField, title, labelFunction, balloonFunction) {
            return ChartsService.getCommonSerialChartSettings({
                categoryAxis: {
                    gridCount: MAX_CHART_ITEMS_COUNT,
                },
                valueAxes: [
                    getValueAxis(valueField + 'valueAxis', labelFunction),
                ],
                graphs: [
                    ChartsService.getCommonLineGraph({
                        valueField: valueField,
                        balloonFunction: balloonFunction,
                    }),
                ],
                titles: [
                    {
                        text: title,
                        size: 15,
                    },
                ],
                autoMargins: true,
                dataProvider: chartData,
            });
        }

        function getValueAxis(id, labelFunction) {
            return ChartsService.getCommonValueAxis({
                id: id,
                labelFunction: labelFunction,
            });
        }

        function buildTableConfig() {
            return {
                hideCheckboxes: true,
                titleSearch: true,
                items: [],
                fields: [
                    {label: 's', path: "siteName", template:`<monitor-offcloud-site-row site-data="item" select-row="item.clickTableRow(site, tunnel)" selected-row="item.selectedTableRow"></monitor-offcloud-site-row>`}
                ],
                alternativeHead: [
                {
                    'label': '',
                    'path': '',
                    'noSort': true
                },
                {
                    'label': 'Peer',
                    'path': 'siteName',
                }, {
                    'label': 'Throughput',
                    'path': 'sumThroughput',
                }, {
                    'label': 'Packet Loss (%)',
                    'path': 'packetLoss',
                }, {
                    'label': 'Latency (ms)',
                    'path': 'latency',
                }, {
                    'label': 'Jitter (ms)',
                    'path': 'jitter',
                },
                ],
                allowPropagation: true,
                pageSize: 10,
                clientSidePaging: true,
                clientSideSearch: true,
                clientSideSort: true,
                multiSelect: false,
                sortList: [{sortField: "protoId", sortDir: "ASC" }],
            };
        }

        ctrl.clickTableRow = (site, tunnel) => {
            if (setSelectedSiteAndTunnel(site, tunnel)) {
                onTableRowSelect();
            }
        };

        const setSelectedSiteAndTunnel = (site, tunnel) => {
            let changed = false;
            let clickedRow = buildClickedTableRowMetaData(site, tunnel);
            if (!_.isEqual(clickedRow, ctrl.selectedSiteAndTunnel)) {
                //not re-assigning ctrl.selectedSiteAndTunnel to keep reference inside table items.
                delete ctrl.selectedSiteAndTunnel.siteId;
                delete ctrl.selectedSiteAndTunnel.tunnelId;
                delete ctrl.selectedSiteAndTunnel.tunnelName;
                _.merge(ctrl.selectedSiteAndTunnel, clickedRow);
                changed = true;
            }
            return changed;
        };

        function buildClickedTableRowMetaData(site, tunnel) {
            if (tunnel) {
                return {
                    siteId: site.protoId,
                    tunnelId: tunnel.protoId,
                    tunnelName: tunnel.siteName,
                };
            } else {
                return {
                    siteId: site.protoId
                };
            }
        }

        function onTableRowSelect() {
            if (ctrl.selectedSiteAndTunnel.siteId !== ctrl.selectedSite.siteId) {
                ctrl.selectedSite = getSiteDataById(ctrl.selectedSiteAndTunnel.siteId);
                showCurrentlySelectedOnMap();
            }
            clearCharts();
        }

        function refreshTable(time) {
            if (ctrl.tableConfig) {
                if(time) {
                    ctrl.tableConfig.refreshViewItems = time;
                } else {
                    ctrl.tableConfig.refreshViewItems = new Date().getTime();
                }
            }
        }

        function runData() {
            if($scope.destroyed) {
                return;
            }

            if(ctrl.realtimeData && ctrl.realtimeData.remoteSite.quality.length > 0) {
                let now = removeMs(new Date().getTime());
                let qualityStats = ctrl.selectedSiteAndTunnel.tunnelId ? ctrl.realtimeData.remoteSite.perTunnelQuality[ctrl.selectedSiteAndTunnel.tunnelId] : ctrl.realtimeData.remoteSite.quality;
                let timeOfFirstStatsPointInCache = qualityStats[0].timestamp;
                let timeOfLastStatsPointInCache = qualityStats[qualityStats.length - 1].timestamp;
                let realtimeDataInterval = INTERVAL;

                if(firstRun) {
                    chartData = initialChartData(timeOfFirstStatsPointInCache);
                    updateCharts(chartData);
                    firstRun = false;
                }
                let timeSeries = chartData;
                let timeOfLastDrawnTimePoint = timeSeries[timeSeries.length - 1].timestamp;

                if(timeOfFirstStatsPointInCache - timeOfLastDrawnTimePoint > TIME_DELAY) {
                    timeSeries.length = 0;
                    timeSeries.push(...initialChartData(timeOfLastStatsPointInCache));
                }

                let pointsToAdd = [];
                let i = 0;
                for(let statsPoint of qualityStats) {
                    if(statsPoint.timestamp > now - TIME_DELAY) {
                        break;
                    }

                    let shouldAdd = true;

                    for(i; i < timeSeries.length; ) {
                        let drawnPoint = timeSeries[i];
                        i++;
                        if(statsPoint.timestamp == drawnPoint.timestamp) {
                            if(!drawnPoint.merged) {
                                angular.extend(drawnPoint, statsPoint);
                                drawnPoint.merged = true;
                            }
                            shouldAdd = false;
                            break;
                        }
                    }

                    if(shouldAdd) {
                        pointsToAdd.push(statsPoint);
                        for(let time = statsPoint.timestamp + INTERVAL; (time < (statsPoint.timestamp + realtimeDataInterval)) && time < now - TIME_DELAY; time += INTERVAL) {
                            pointsToAdd.push(_.merge({}, statsPoint, {timestamp: time}));
                        }
                    }

                }
                timeSeries.push(...pointsToAdd);
                if(timeSeries.length > MAX_CHART_ITEMS_COUNT) {
                    timeSeries.splice(0, timeSeries.length - MAX_CHART_ITEMS_COUNT);
                }
                updateCharts(timeSeries);
            }
            runTimeout = $timeout(function() {
                runData();
            }, INTERVAL, false);
        }

        function updateCharts(data) {
            for(let chart of charts) {
                chart.dataProvider = data;
                (function(currentChart){
                    $timeout(function() {
                        currentChart.validateData();
                    }, 0, false);
                })(chart);
            }
        }

        function removeMs(time) {
            if(time) {
                time = time - (time % 1000);
            }
            return time;
        }

        function updateSelectedTableRaw() {
            if(ctrl.selectedSite) {
                if (ctrl.selectedSiteAndTunnel.siteId !== ctrl.selectedSite.siteId) {
                    for(let item of ctrl.tableConfig.items) {
                        if(ctrl.selectedSite.siteId === item.protoId) {
                            setSelectedSiteAndTunnel({protoId: item.protoId});
                            break;
                        }
                    }
                }
            } else {
                if(ctrl.tableConfig.items.length > 0) {
                    let item = ctrl.tableConfig.items[0];
                    setSelectedSiteAndTunnel({protoId: item.protoId});
                    ctrl.selectedSite = getSiteDataById(item.protoId);
                    showCurrentlySelectedOnMap();
                    clearCharts();
                }
            }
        }

        function getRT() {
            if (stop) {
                return;
            }

            store.fetch({
                path: '/offcloudSiteLatestStats?account=' + ctrl.accountId + '&pid=' + currentSiteId,
                success: function(data) {
                    if($scope.destroyed) {
                        return;
                    }
                    if(data) {
                        data.data = processNewData(data.data);
                        ctrl.tableConfig.items = mergeData(data.data);
                        if (!data.isConnectedToPop) {
                            ctrl.tableConfig.noDataMessage = "Not Connected";
                        } else if (!data.newestTimeStamp && data.data !== null) {
                            ctrl.tableConfig.noDataMessage = "Loading Real-Time Statistics, Please wait";
                        }
                        ctrl.tableConfig.searchVal = ''; // this fixes search after table update.
                        updateSelectedTableRaw();
                        refreshTable(data.timeStamp);
                        refreshMap();
                        $scope.$digest();
                        if(firstRun) {
                            refreshTable(data.timeStamp);
                            if(!runTimeout) {
                                runData();
                            }
                        }
                    }
                }
            });

            if(ctrl.selectedSite && ctrl.selectedSite.offCloudEnable) {
                let selectedSiteId = ctrl.selectedSite.siteId;
                store.fetch({
                    path: '/offcloudRemoteSiteStats?&account=' + ctrl.accountId + '&pid=' + currentSiteId + '&remoteSite=' + selectedSiteId,
                    success: function(data) {
                        if ($scope.destroyed) {
                            return;
                        }
                        if (data) {
                            let $notificationsEl = $('.ngn');
                            if (data.status && data.status === 'ERROR') {
                                if ($notificationsEl.css('display') !== 'block') {
                                    $scope.$root.showNotification('error', data.notifications[0].message, data.notifications[0].message, true, true);
                                }
                            } else {
                                if ($notificationsEl.css('display') == 'block') {
                                    $scope.$root.hideNotification();
                                }
                                ctrl.realtimeData = data;
                            }
                        }
                    }
                });
            }

        }

        function mergeData(newData) {
            let siteDataList = ctrl.siteMapData;
            let mergedData = [];

            newData.forEach((newSiteData) => {
                let oldTableData = ctrl.tableConfig.items.filter(site => site.protoId === newSiteData.protoId)[0];
                if(oldTableData) {
                    oldTableData = {...oldTableData, ...newSiteData};
                    mergedData.push(oldTableData);
                } else {
                    mergedData.push(newSiteData);
                }

                let oldSiteData = siteDataList.filter(site => site.siteId === newSiteData.protoId)[0];
                if (oldSiteData) {
                    newSiteData.location = oldSiteData.location;
                    newSiteData.siteName = oldSiteData.siteName;
                    newSiteData.siteId = oldSiteData.siteId;
                    newSiteData.countryCode = oldSiteData.countryCode;
                    oldSiteData.connected = newSiteData.hasCatoConnectivity;
                    oldSiteData.offCloudEnable = newSiteData.hasOffCloudConnectivity;
                }

            });


            return mergedData;
        }

        function processNewData(data) {
            data.forEach(function(rtStats) {
                if (rtStats.quality) {
                    rtStats.quality.sumThroughput = rtStats.quality.upstreamThroughput + rtStats.quality.downstreamThroughput;
                    rtStats.clickTableRow = ctrl.clickTableRow; //bind clickTableRow function to be able to pass it to monitor-offcloud-site-row component
                    rtStats.selectedTableRow = ctrl.selectedSiteAndTunnel; //bind selectedTableRow function to be able to pass it to monitor-offcloud-site-row component
                }
            });
            return data;
        }

        function buildConnectionLines() {
            let currentSiteData = getCurrentSiteData();
            let siteDataList = ctrl.siteMapData;
            // location 0:0 means we can't calculate site location
            // we are not drawing lines if we can't draw site location.
            if(isLocationUnknown(currentSiteData)) {
                return [];
            }

            let lines = [];
            for(let i = 0; i < siteDataList.length; i++) {
                if(siteDataList[i].siteId == currentSiteData.siteId || (currentSiteData.location.latitude == siteDataList[i].location.latitude && currentSiteData.location.longitude == siteDataList[i].location.longitude)) {
                    continue;
                }
                if(siteDataList[i].offCloudEnable && siteDataList[i].location && (siteDataList[i].location.latitude || siteDataList[i].location.longitude)) {
                    let line = {
                        latitudes: [currentSiteData.location.latitude, siteDataList[i].location.latitude],
                        longitudes: [currentSiteData.location.longitude, siteDataList[i].location.longitude],
                    };
                    lines.push(line);
                }
            }
            return lines;
        }

        function getCurrentSiteData() {
            return getSiteDataById(currentSiteId);
        }

        function getSiteDataById(id) {
            let siteDataList = ctrl.siteMapData;
            let currentSite;
            for(let i = 0; i < siteDataList.length; i++) {
                if(id === siteDataList[i].siteId) {
                    currentSite = siteDataList[i];
                    break;
                }
            }
            return currentSite;
        }

        function buildSiteImages() {
            let siteDataList = ctrl.siteMapData;
            let siteMapData = [];
            siteDataList.forEach(function(site) {
                if(!isLocationUnknown(site.location)) {
                    let siteConfig = createSiteImgCfgFromSite(site, siteMapData);
                    if(siteConfig) {
                        siteMapData.push(siteConfig);
                    }
                }
            });
            return siteMapData;
        }

        function htmlForTooltip(color, svgPath) {
            return `
                <svg width='12' height='12' viewBox='0 0 24 24'>
                    <path d='${svgPath}' fill='${color}'></path>
                </svg>
            `;
        }

        function createSiteImgCfgFromSite(site, mapSiteImages) {


            for(let i = 0; i < mapSiteImages.length; i++) {
                let siteImgCfg = mapSiteImages[i];
                //not drawing points on top of each other, adding to balloon text instead.
                if(siteImgCfg.latitude == site.location.latitude && siteImgCfg.longitude == site.location.longitude) {
                    siteImgCfg.selectable = false;//can't select since there is few sites represented by one image.
                    if(!siteImgCfg.connected && site.offCloudEnable && currentSiteId != site.siteId) {
                        siteImgCfg.connected = true;
                        siteImgCfg.svgPath = remoteConnectedSVG;
                    }
                    if(currentSiteId == site.siteId) {
                        siteImgCfg.connected = site.connected;
                        siteImgCfg.svgPath = currentSVG;
                        siteImgCfg.color = site.connected ? connectedColor : disconnectedColor;
                        siteImgCfg.scale = 1.2;
                        let currentHTML = htmlForTooltip(siteImgCfg.color, currentSVG);
                        siteImgCfg.balloonText = currentHTML + site.siteName + '</br>' + siteImgCfg.balloonText;
                    } else {
                        siteImgCfg.balloonText += "<br/>";
                        if(site.connected) {
                            siteImgCfg.balloonText += connectedHTML;
                        } else {
                            siteImgCfg.balloonText += disconnectedHTML;
                        }

                        if(site.offCloudEnable) {
                            siteImgCfg.balloonText += offcloudLinkHTML;
                        } else {
                            siteImgCfg.balloonText += offcloudLinkOffHTML;
                        }
                        siteImgCfg.balloonText += site.siteName;
                    }
                    return;
                }
            }

            let siteImgCfg = {};
            siteImgCfg.id = site.siteId;
            siteImgCfg.title = site.siteName;
            siteImgCfg.latitude = site.location.latitude;
            siteImgCfg.longitude = site.location.longitude;
            siteImgCfg.connected = site.connected;

            if(siteImgCfg.id == currentSiteId) {
                siteImgCfg.scale = 1.2;
                siteImgCfg.selectable = false;
                siteImgCfg.color =  site.connected ? connectedColor : disconnectedColor;
                siteImgCfg.svgPath = currentSVG;
                siteImgCfg.balloonText = htmlForTooltip(siteImgCfg.color, currentSVG);
            } else {
                if(site.connected) {
                    siteImgCfg.svgPath = remoteConnectedSVG;
                    siteImgCfg.color = connectedColor;
                    siteImgCfg.balloonText = connectedHTML + offcloudLinkHTML;
                } else {
                    siteImgCfg.svgPath = remoteDisconnectedSVG;
                    siteImgCfg.color = disconnectedColor;
                    siteImgCfg.selectable = false;
                    siteImgCfg.balloonText = disconnectedHTML + offcloudLinkOffHTML;
                }
                siteImgCfg.scale = 0.8;
            }

            if(!site.offCloudEnable) {
                siteImgCfg.selectable = false;
            }

            siteImgCfg.balloonText += siteImgCfg.title;
            return siteImgCfg;
        }

        // adding location as center of the country for site's that server doesn't know location.
        function addLocationWhereIsMissing(mapChart) {
            let siteDataList = ctrl.siteMapData;
            let areas = mapChart.dataProvider.areas;
            siteDataList.forEach(function(site) {
                if(isLocationUnknown(site.location)) {
                    for(let i = 0; i < areas.length; i++) {
                        let currentArea = areas[i];
                        if(site.countryCode == currentArea.id) {
                            site.location.latitude = mapChart.getAreaCenterLatitude(currentArea);
                            site.location.longitude = mapChart.getAreaCenterLongitude(currentArea);
                            break;
                        }
                    }
                }
            });
        }

        function isLocationUnknown(location) {
            if(!location) {
                return true;
            }
            return location.longitude == 0 && location.latitude == 0
        }

        function loadSiteMapData () {
            store.fetch({
                path: '/accountSiteLocations',
                queryParams: { accountId: ctrl.accountId },
                success: function (data) {
                    ctrl.siteMapData = data;
                    IntervalService.dynamicInterval(getRT,$scope.$id, 'monitorOffCloudGetRt',false);
                    drawMap();
                }
            });
        }

        function showCurrentlySelectedOnMap() {
            if(ctrl.selectedSite) {
                let id = ctrl.selectedSite.siteId;
                let mapImages = mapChart.dataProvider.images;
                for(let image of mapImages) {
                    if(image.id == id) {
                        mapChart.selectObject(image);
                        return;
                    }
                }
            }
        }

        function clickMapObjectListener(event) {
            if(event.type == 'clickMapObject') {
                let mapObject = event.mapObject;
                if(ctrl.selectedSite.siteId != mapObject.id) {
                    ctrl.selectedSite = getSiteDataById(mapObject.id);
                    updateSelectedTableRaw();
                    refreshTable();
                    clearCharts();
                    $scope.$digest();
                }
            }
        }

        function clearCharts() {
            chartData = initialChartData();
            ctrl.realtimeData = null;
            updateCharts(chartData);
        }

        function drawMap() {
            mapChart = createAmMap();
            addLocationWhereIsMissing(mapChart);
            refreshMap();
        }

        function refreshMap() {
            mapChart.dataProvider.images = buildSiteImages();
            mapChart.dataProvider.lines = buildConnectionLines();

            // create an array of all areas objects, selected by sites' country codes, that allow off-cloud transport
            let offCloudAreaIds = _.uniq(ctrl.siteMapData.filter(x => x.offCloudEnable === true).map(site => site.countryCode));
            let zoomToAreas = [];
            let area;
            for(var i = 0; i < offCloudAreaIds.length; i++) {
                if (area = mapChart.getObjectById(offCloudAreaIds[i])) {
                    zoomToAreas.push(area);
                }
            }

            if (mapChart.dataProvider.zoomLevel != mapChart.zoomLevel()) {
                mapRepositioned = true;
            }
            mapChart.dataProvider.zoomLevel = mapChart.zoomLevel();
            mapChart.dataProvider.zoomLatitude = mapChart.zoomLatitude();
            mapChart.dataProvider.zoomLongitude = mapChart.zoomLongitude();
            mapChart.validateNow();
            // zoom to the group of areas we created above. should execute after validateNow so these settings will not get overwritten
            if (!mapRepositioned) {
                mapChart.zoomToGroup(zoomToAreas);
            }

            showCurrentlySelectedOnMap();
        }

        function createAmMap() {
            let amMapChart = AmCharts.makeChart("catoWorldMap", {
                type: "map",
                theme: "none",
                mouseWheelZoomEnabled: true,
                zoomDuration: 0.5,
                hideCredits: true,
                backgroundZoomsToTop: false,
                linesAboveImages: true,
                preventDragOut: true,

                dataProvider: {
                    map: "worldLow",
                    getAreasFromMap: true,
                    zoomLevel: 1.5,
                    zoomLongitude: 0,
                    zoomLatitude: 0,
                },

                areasSettings: {
                    autoZoom: false,
                    selectable: false,
                    balloonText: '',
                    color: mapAreaColor,
                    rollOverOutlineColor: "white",
                },

                balloon: {
                    fillColor: "#FFFFFF",
                    shadowAlpha: 1,
                    fillAlpha: 1,
                    shadowColor: "black",
                    cornerRadius: 9,
                    borderThickness: 1.5,
                    verticalPadding: 10,
                    horizontalPadding: 10,
                    textAlign: 'left',
                },

                imagesSettings: {
                    selectable: true,
                },

                zoomControl: {
                    homeButtonEnabled: false,
                    zoomFactor: 1.5
                },

                linesSettings: {
                    arc: -0.8, // this makes lines curved. Use value from -1 to 1
                    arrow: "none",
                    color: connectedColor,
                    alpha: 0.4,
                    arrowAlpha: 1,
                    arrowSize: 6,
                    dashLength:2,
                    thickness: 2.5,
                },
            });
            amMapChart.addListener('clickMapObject', clickMapObjectListener);
            amMapChart.addListener('dragCompleted', () => {mapRepositioned = true;});
            return amMapChart;
        }

        ctrl.$onDestroy = () => {
            $scope.loaded = false;
            $scope.destroyed = true;
            $scope.$root.realtime = false;
            if(mapChart) {
                mapChart.clear();
            }
            if(runTimeout) {
                $timeout.cancel(runTimeout);
            }
            IntervalService.cancelDynamicInterval($scope.$id, 'monitorOffCloudGetRt');
            GeneralUtilsService.cleanAmChartsFromScope($element);

            if ($('.ngn').css('display') == 'block') {
                $scope.$root.hideNotification();
            }
        };

    }


});
